export enum EditStatus {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOT_PERFORMED = 'NOT_PERFORMED',
    PHONE_VALIDATION_ERROR = 'PHONE_VALIDATION_ERROR',
}
